import { render, staticRenderFns } from "./SignUpOptions.vue?vue&type=template&id=10409494&scoped=true"
import script from "./SignUpOptions.vue?vue&type=script&lang=ts"
export * from "./SignUpOptions.vue?vue&type=script&lang=ts"
import style0 from "./SignUpOptions.vue?vue&type=style&index=0&id=10409494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10409494",
  null
  
)

export default component.exports